import React, { useEffect, useRef } from 'react';
import './JobCards.css';
import JobCardItem from './JobCardItem';

const JOB_TEXTS = [
  'Full & partial rewires',
  'Replacement consumer units',
  'LED lighting installation/upgrade',
  'Fault finding',
  'Electrical Installation Condition Report (EICR)',
  'Outdoor lighting & power',
  'Smoke/CO detectors',
  'Security lighting/cameras',
];

function JobCards() {
  const marqueeInnerRef = useRef(null);
  const firstListRef = useRef(null);

  useEffect(() => {
    const setVars = () => {
      const first = firstListRef.current;
      const inner = marqueeInnerRef.current;
      if (!first || !inner) return;

      // Gap between the two lists (matches CSS margin-left on duplicate)
      const GAP = 1;

      // Shift = exactly one list width + the gap between the two copies.
      // When the animation completes, the second copy is now where the
      // first started → seamless loop.
      const shift = first.offsetWidth + GAP;

      inner.style.setProperty('--marquee-shift', `${shift}px`);

      // Duration: ~60px per second feels natural; clamp to at least 8s
      const duration = Math.max(8, Math.round(shift / 60));
      inner.style.setProperty('--marquee-duration', `${duration}s`);
    };

    // Small delay lets the DOM paint so offsetWidth is accurate
    const timer = setTimeout(setVars, 50);
    window.addEventListener('resize', setVars);
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', setVars);
    };
  }, []);

  return (
    <div className="jobs-section-container">
      <div className="job-cards-container marquee">
        <div className="marquee__inner" ref={marqueeInnerRef}>
          {/* Original list */}
          <ul className="job-cards" ref={firstListRef}>
            {JOB_TEXTS.map((t, i) => (
              <JobCardItem key={i} text={t} />
            ))}
          </ul>

          {/* Duplicate for seamless loop — hidden from screen readers */}
          <ul className="job-cards job-cards--duplicate" aria-hidden="true">
            {JOB_TEXTS.map((t, i) => (
              <JobCardItem key={'dup-' + i} text={t} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}

export default JobCards;